"use client"

import { fetchPostByCategories } from "@/services/postServices"
import { getSiteIdFromHost } from "@/sites/config"
import { PostData, UsePromotionListResult } from "@/types/types"
import { useCallback, useEffect, useState } from "react"

export const usePromotionListByCategory = (
  categoryId: number | null | undefined,
  pageSize: number = 20,
  locale: string = "vi",
): UsePromotionListResult => {
  const [posts, setPosts] = useState<PostData[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const host = window.location.host
  const siteId = getSiteIdFromHost(host)

  const fetchPromotions = useCallback(async () => {
    if (!categoryId) {
      setPosts([])
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await fetchPostByCategories([String(categoryId)], {
        page: "1",
        pageSize: String(pageSize),
        locale,
        siteId
      })

      if (response?.data && response.data.length > 0) {
        setPosts(response.data)
      } else {
        setPosts([])
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unknown error")
      setPosts([])
    } finally {
      setLoading(false)
    }
  }, [categoryId, pageSize, locale, siteId])

  useEffect(() => {
    fetchPromotions()
  }, [fetchPromotions])

  return {
    posts,
    loading,
    error,
  }
}

